import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { CAPACITOR_EXPORT_PLUGIN_NAME } from '../pluginConstants';
import { ExportPlugin } from './definitions';

const ExportRaw = registerPlugin<ExportPlugin>(CAPACITOR_EXPORT_PLUGIN_NAME);
const Export = withBridgedStackTrace(ExportRaw, CAPACITOR_EXPORT_PLUGIN_NAME);

export { Export };
